import {
  type HttpPaginatedRequestFn,
  type HttpRequestFn,
  type UseHttpOptions,
  type UsePaginatedHttpOptions,
  useHttp,
  usePaginatedHttp,
} from '@tundr/http';
import type {
  GetCompanyListPayload,
  GetCompanyListResponse,
  GetCurrentCompanyResponse,
} from './company-api.types.ts';

export const COMPANIES_BASE_API_URL = 'companies';

// GET ALL COMPANIES FOR HR
const getHrCompanyList: HttpPaginatedRequestFn<
  GetCompanyListResponse,
  GetCompanyListPayload
> = (http) => (params) => {
  return http.get(COMPANIES_BASE_API_URL, {
    params,
  });
};

export const useGetHrCompanyList = (
  options: UsePaginatedHttpOptions<
    GetCompanyListResponse,
    GetCompanyListPayload
  > = {},
) => usePaginatedHttp(getHrCompanyList, options);

// GET CURRENT COMPANY DETAIL
const getCurrentCompany: HttpRequestFn<GetCurrentCompanyResponse, void> =
  (http) => () => {
    return http.get(`${COMPANIES_BASE_API_URL}/current`);
  };

export const useGetCurrentCompany = (
  options: UseHttpOptions<GetCurrentCompanyResponse, void> = {},
) => useHttp(getCurrentCompany, options);
